<div class="contentbox">
  <div class="row">
    <div class="col col-12">
      <div class="d-flex justify-content-center align-content-center align-items-md-center" style="height: 300px; flex-direction: column;">
        <h2>
          You don't have access to the page or resource you were trying to reach.
        </h2>
        <p>Please check whether you are using the correct URL and try again or click <a [href]="dashboardUrl">here</a> to go the Log in/Home page.</p>
        <p>If issue persists, please reach out to <a href="mailto:help@medpt.com">help&#64;medpt.com</a> with your Log in ID, URL and brief description of issue or call us at <a href="tel:+1-847-440-9447">+1-847-440-9447</a> / <a href="tel:1-800-387-9091">1-800-387-9091</a>.</p>
      </div>
    </div>
  </div>
</div>
